import React, { useReducer, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";
import {
  detailsReducer,
  detailsInitialState,
} from "../../../reducers/module/detailsReducer";
import Details from "./partials/details/Details";
import { loadItemGeneral } from "../../../helpers/ModuleHelperFunctions";



const NotificationsView = () => {
   const { setBreadcrumb } = useContext(BreadcrumbContext);
   const [detailsState, detailsDispatch] = useReducer(detailsReducer,detailsInitialState);
   
   let { id } = useParams();
   
   
   const loadItem = async () => {
     await loadItemGeneral(id,`${moduleConfig.url}/${id}`,detailsDispatch)
   };
   useEffect(() => {
     loadItem();
     setBreadcrumb([moduleConfig.breadcrumbs.listing, moduleConfig.breadcrumbs.details]);
   }, [id]);

  return (
    <DashboardLayout>
      {(!detailsState.data.item && detailsState.isFetching) ? (
        <ContainerLoading />
      ) : (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
            
              {detailsState.data.item && (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl={moduleConfig.url}
                  ></ModuleHeader>

                 

                  <Details
                    item={detailsState.data.item}
                    members={detailsState.data.members}
                    moduleConfig={moduleConfig}
                    detailsDispatch={detailsDispatch}
                    loadItem={loadItem}
                    loading={detailsState.isFetching}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default NotificationsView;
